import React, {
	useState,
	useEffect,
	useCallback,
	//useMemo,
} from 'react';

import { useSelector, useDispatch } from 'react-redux';

import Loading from 'components/loading.js';

import {
	actionSetMessage,
	//actionResetMessages
} from 'components/messages/actions.js';
import { actionFetchTimezones } from './actions.js';

import { GenericListSelect } from 'components/genericListSelect';

export const TimezoneSelect = (props) => {
	const timezones = useSelector((state) => state.timezones); // store main weighers data for this client
	const timezonesLoaded = useSelector((state) => state.timezonesLoaded); //initial load event has completed
	const [timezonesList, setTimezonesList] = useState([]); //	local data for graph or report
	const [wloading, setWloading] = useState(false);
	const dispatch = useDispatch();

	const showMessage = useCallback(
		(data) => dispatch(actionSetMessage(data)),
		[dispatch]
	);

	useEffect(() => {
		// load the weighers from the api if they havent been loaded
		if (!timezonesLoaded) {
			setWloading(true); //reset loading flag
			dispatch(actionFetchTimezones(setWloading, showMessage));
		}
	}, [timezonesLoaded, showMessage, setWloading, dispatch]);

	useEffect(() => {
		const makeWeighersList = () => {
			if (timezones === null || timezones === undefined) {
				return [];
			} else {
				const timezoneList = timezones.reduce(function (res, set) {
					const displaySet = set.timezone;
					res.push(displaySet);
					return res;
				}, []);
				return timezoneList;
			}
		};
		const timezoneList = makeWeighersList(timezones);
		setTimezonesList(timezoneList);
	}, [timezones]);

	// const handleChange = (evt) =>{
	// 	evt.persist()
	// 	setTimezone(evt.target.value)
	// }

	return (
		<>
			{wloading ? (
				<Loading loading={wloading} />
			) : (
				<GenericListSelect
					id="timezone"
					label="Time zone"
					dataArray={timezonesList}
					cols={props.cols}
					controlStyle={props.controlStyle}
					handleChange={(evt) => props.handleChange(evt)}
					value={props.value}
					required={props.required}
					//pattern = {'^\d+$'}	// integer
					pattern={'^[a-zA-Z]+[a-zA-Z0-9_ -]+$'}
					invalidMsg="Select a time zone"
					lock={props.lock}
				/>
			)}
		</>
	);
};
